// 车联网 - 车辆监控管理 - 车辆监控信息提醒
export default [{
  path: 'vehicleMessage',
  name: 'vehicleMessage',
  component: function component() {
    return import('@/views/vehicleMessage/index');
  }
}, {
  path: 'carWaringConfigList',
  name: 'carWaringConfigList',
  component: function component() {
    return import('@/views/vehicleMessage/config/index');
  }
}, {
  path: 'carWaringConfigDetail',
  name: 'carWaringConfigDetail',
  component: function component() {
    return import('@/views/vehicleMessage/config/detail');
  }
}, {
  path: 'carWaringConfigEdit',
  name: 'carWaringConfigEdit',
  component: function component() {
    return import('@/views/vehicleMessage/config/edit');
  }
}];
export var activeMenu = {
  '/main/carWaringConfigList': '/main/vehicleMessage',
  '/main/carWaringConfigDetail': '/main/vehicleMessage',
  '/main/carWaringConfigEdit': '/main/vehicleMessage'
};